<template>
    <base-modal-confirm
        @modalClose="saveAndExit"
        @confirmAndExit="saveAndExit"
        :show-modal="showModal"
        :modal-heading="$t('INSTANCE_ERROR_HEADER')"
        :modal-copy="$t('INSTANCE_ERROR_BODY')"
        :cta-copy="$t('OK')"
        :show-cancel="false"
    />
</template>

<script>
    import BaseModalConfirm from './BaseModalConfirm.vue';

    import allStores from '../stores/all';

    export default {
        mixins: [allStores],

        components: {
            BaseModalConfirm,
        },

        data() {
            return {};
        },

        computed: {
            showModal() {
                return this.customizerStore.instanceError;
            },
        },

        methods: {
            saveAndExit() {
                this.customizerStore.setInstanceError(false);
            },
        },
    };
</script>
